import React from 'react';
import pt from 'prop-types';

import { slugify } from 'utils';

import Form from 'components/form/form';
import Field from 'components/form/field';
import Modal from 'components/modal';

const actions = [{ label: 'Save', type: 'submit' }];

const FIELD_NAME_ID = 'name';

export default class ModalTemplateNew extends React.PureComponent {
  static propTypes = {
    options: pt.array.isRequired,
    defaultTemplate: pt.string,
    defaultName: pt.string,
    rename: pt.bool,
    onSubmit: pt.func,
    onClose: pt.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      fields: { [FIELD_NAME_ID]: props.defaultName || '' },
    };
  }

  onChangeName = (_event, value) => {
    this.setState((state) => ({
      ...state,
      fields: { ...state.fields, [FIELD_NAME_ID]: slugify(value) || '' },
    }));
  };

  onSubmitForm = (values) => {
    const { onSubmit } = this.props;
    return onSubmit({ ...values, ...this.state.fields });
  };

  render() {
    const {
      rename = false,
      options,
      defaultTemplate,
      onSubmit,
      onClose,
    } = this.props;

    return (
      <Form onSubmit={onSubmit} autoFocus>
        <Modal
          title={rename ? 'Rename template' : 'Create new template'}
          width={480}
          actions={actions}
          onClose={onClose}
          closable={true}
          tapout={true}
        >
          <div className="row">
            <Field
              type="text"
              name={FIELD_NAME_ID}
              label="Name"
              className="span4"
              value={this.state.fields[FIELD_NAME_ID]}
              required
              onChange={this.onChangeName}
            />
          </div>

          {!rename && (
            <div className="row">
              <Field
                type="select"
                name="template"
                label="Copy template"
                className="span4"
                defaultValue={defaultTemplate}
                options={options}
                required
              />
            </div>
          )}
        </Modal>
      </Form>
    );
  }
}
